import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { CofConfigId } from "../../gql-generated/types";

import { useSelectedLensCentralOrganizationNotIncludesCamkitOrgs } from "./useSelectedLensCentralOrganizationNotIncludesCamkitOrgs";
import { useSelectedLensFolder } from "./useSelectedLensFolder";
import { useSelectedLensFolderV3 } from "./useSelectedLensFolderV3";
import { useSelectedOrganization } from "./useSelectedOrganization";

export interface SelectedOrganizationAndLensFolder {
    orgId?: string;
    lensFolderId?: string;
}
export const useSelectedOrganizationAndLensFolderV3 = (): SelectedOrganizationAndLensFolder => {
    const lensFolderData = useSelectedLensFolderV3();
    const orgData = useSelectedLensCentralOrganizationNotIncludesCamkitOrgs();

    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;

    const selectedOrg = useSelectedOrganization();
    const { lensFolder: selectedFolder } = useSelectedLensFolder();

    if (isMyLensesOrgsV2Enabled) {
        const { id: orgId } = selectedOrg ?? {};
        const { id: lensFolderId, parentName } = selectedFolder ?? {};

        return {
            orgId: orgId ?? parentName,
            lensFolderId,
        };
    }

    const { id: lensFolderId, organizationId: orgIdFromLensFolder } = lensFolderData ?? {};
    const { id: orgIdFromURL } = orgData ?? {};

    const orgId = orgIdFromLensFolder ?? orgIdFromURL;

    return {
        orgId,
        lensFolderId,
    };
};
